import React, { memo, useCallback } from "react";

import { faEnvelope } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge as MaterialBadge } from "@material-ui/core";
import { uniqBy } from "lodash/array";
import { useSelector } from "react-redux";
import styled from "styled-components/macro";

import { BusinessModalSection } from "constants/navigation";

import { getSaleyardName, openEditBusinessModal } from "lib/navigation";

import { getBusinessById } from "selectors";

import { EMPTY_ARRAY, EMPTY_OBJECT } from "lib/index";

const PaddedBadge = styled(MaterialBadge)`
  /* Same as the default \`word-spacing\` to allow embedding inline in text */
  margin: 0.25em;
  z-index: 0;
`;

const EmailRecipientCount = React.memo(({ recipientCount, onClick }) => {
  const color = recipientCount ? "primary" : "error";
  return (
    <PaddedBadge
      data-tour="emailRecipientBadge"
      badgeContent={recipientCount}
      showZero
      color={color}
    >
      <FontAwesomeIcon icon={faEnvelope} size="2x" onClick={onClick} />
    </PaddedBadge>
  );
});

export const MasterBusinessEmailRecipientCount = memo(props => {
  const { masterBusinessId, saleyardName = getSaleyardName() } = props;

  const recipientCount = useSelector(state => {
    const primaryDeploymentBusiness =
      getBusinessById(masterBusinessId)(state) || EMPTY_OBJECT;

    const emailRecipients =
      primaryDeploymentBusiness.emailRecipients || EMPTY_ARRAY;
    const emailRecipientsWithEmails = emailRecipients.filter(er => er.email);
    const otherEmailRecipients =
      primaryDeploymentBusiness.otherEmailRecipients || EMPTY_ARRAY;
    const otherEmailRecipientsWithEmails = otherEmailRecipients.filter(
      er => er.email,
    );

    const businessUsers =
      primaryDeploymentBusiness.businessUsers || EMPTY_ARRAY;

    // FIXME the BusinessUser counting here is wrong here - AG-5618
    //  It doesn't take into account either of:
    //   - Saleyard.enable_automatic_buyer_portal (count all BusinessUsers when true for yard)
    //   - BusinessUser.restrict_to_listed_sale_yards (always count this BusinessUser when False)
    //  both of which aren't currently available to frontend.
    const saleyardBusinessUsers = businessUsers.filter(businessUser =>
      businessUser.saleYards.includes(saleyardName),
    );

    return uniqBy(
      [
        ...emailRecipientsWithEmails,
        ...otherEmailRecipientsWithEmails,
        ...saleyardBusinessUsers,
      ],
      "email",
    ).length;
  });

  const onClickRecipientCount = useCallback(
    () =>
      openEditBusinessModal(
        masterBusinessId,
        null,
        BusinessModalSection.EMAIL_RECIPIENTS,
      ),
    [masterBusinessId],
  );

  return (
    <EmailRecipientCount
      onClick={onClickRecipientCount}
      recipientCount={recipientCount}
    />
  );
});
